import React, { FC } from "react";
import FormAttentionPresence from "./FormAttentionPresence";
import FormAttentionPublicity from "./FormAttentionPublicity";

export interface AttentionProps {
  presence?: "yes" | "no";
  publicity?: "yes" | "no";
}

const FormAttention: FC<AttentionProps> = ({ publicity, presence }) => {
  return (
    <>
      {publicity && <FormAttentionPublicity publicity={publicity} />}
      {presence && <FormAttentionPresence presence={presence} />}
    </>
  );
};

export default FormAttention;
